import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from 'haba-core';
import {
  checkoutTranslationChunksConfig,
  checkoutTranslations,
} from 'haba-featurelibs/checkout/assets';
import { CheckoutRootModule, CHECKOUT_FEATURE } from 'haba-featurelibs/checkout/root';

@NgModule({
  declarations: [],
  imports: [CheckoutRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CHECKOUT_FEATURE]: {
          module: () => import('haba-emporix').then((m) => m.CheckoutEmporixModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: checkoutTranslations,
        chunks: checkoutTranslationChunksConfig,
      },
    }),
  ],
})
export class CheckoutFeatureModule {}
